export default function Main(data) {
  return window.btoa(JSON.stringify(data))
}
